import { useCallback, useMemo } from "react";

import { useApi } from "shared/services/api/useApi";
import { useQuery } from "react-query";

export const useTitles = () => {
    const { getDataAsync, } = useApi();

    const getTitlesFilter = useCallback(
        async (params) => {
            const payload = await getDataAsync("titlesFilter", { params: params });
            return payload.json();
        },
        [getDataAsync]
    );

    const getUserTitlesApiCall = useCallback(
        async ({ userId }) => {
            const response = await getDataAsync("userTitles", {
                urlParams: [{ name: "$userId", value: userId }]
            });

            const result = response.status === 204
                ? null
                : response.json();

            return result;
        },
        [getDataAsync]
    );

    return useMemo(() => {
        const useGetUserTitles = (dataObj) =>
            useQuery({
                queryKey: ["userTitles", dataObj],
                queryFn: () => getUserTitlesApiCall(dataObj),
                refetchOnMount: true,
                refetchOnReconnect: false,
            });
        return {
            getTitlesFilter,
            useGetUserTitles
        };
    }, [getTitlesFilter, getUserTitlesApiCall]);
};
